
const NUMBER = 'Number'
const NativeNumber = globalThis[NUMBER]
const NumberPrototype = NativeNumber.prototype

function isObject (argument) {
  return typeof argument === 'object' ? argument !== null : typeof argument === 'function'
}

function inheritIfRequired ($this, dummy, Wrapper) {
  let NewTarget, NewTargetPrototype
  if (
    Object.setPrototypeOf &&
    typeof (NewTarget = dummy?.constructor) === 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) {
    Object.setPrototypeOf($this, NewTargetPrototype)
  }
  return $this
}

function tryParseInt (val) {
  try {
    const out = parseInt(val)
    return out || val
  } catch (err) {
    return val
  }
}

/**
 *
 * @param {unknown} value
 * @returns {number}
 */
export default function Integer (value) {
  let number

  switch (typeof value) {
    case 'string':
      number = ~~tryParseInt(value)
      break
    case 'number':
      number = ~~value
      break
    default:
      number = ~~NativeNumber(value || 0)
      break
  }

  if (number > Integer.MAX_SAFE_INTEGER) {
    throw new Error('value is exceeds Integer.MAX_SAFE_INTEGER')
  }
  if (number < Integer.MIN_SAFE_INTEGER) {
    throw new Error('value is under Integer.MIN_SAFE_INTEGER')
  }
  if (this instanceof Integer || (this && this.constructor && this.constructor.name === 'Integer')) {
    return inheritIfRequired(Object(number), number, Integer)
  }

  return number
}

/**
 *
 * @param {unknown} value
 * @param {number} bits
 * @returns {number}
 */
export function Uinteger (value, bits = 32) {
  let number

  switch (bits) {
    case 24:
      number = value & 0xFFFFFF
      break
    case 16:
      number = value & 0xFFFF
      break
    case 8:
      number = value & 0xFF
      break
    case 6:
      number = value & 0x3F
      break
    case 5:
      number = value & 0x1F
      break
    case 4:
      number = value & 0xF
      break
    case 32:
    default:
      number = value >>> 0
      break
  }

  if (!this) return number

  if (this instanceof Uinteger || (this && this.constructor && this.constructor.name === 'Uinteger')) {
    return inheritIfRequired(Object(number), number, Uinteger)
  }

  return number
}

Integer.MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF
Integer.MIN_SAFE_INTEGER = -0x1FFFFFFFFFFFFF
Integer.prototype = NumberPrototype
Integer.prototype[Symbol.toStringTag] = 'Integer'
Uinteger.prototype[Symbol.toStringTag] = 'Uinteger'

/**
 *
 * @returns {number}
 */
Integer.prototype.abs = function () {
  return this > 0 ? this.valueOf() : -this
}

/**
 *
 * @returns {Integer}
 */
Integer.prototype.divide = function (other) {
  return new Integer(this.valueOf() / other)
}

/**
 *
 * @returns {Integer}
 */
Integer.prototype.multiply = function (other) {
  return new Integer(this.valueOf() * other)
}

/**
 *
 * @returns {Integer}
 */
Integer.prototype.add = function (other) {
  return new Integer(this.valueOf() + other)
}

/**
 *
 * @returns {Integer}
 */
Integer.prototype.subtract = function (other) {
  return new Integer(this.valueOf() - other)
}

Integer.abs = function (number) {
  const n = Integer(number)
  return n > 0 ? n : -n
}

Integer.unsigned = function (number) {
  const n = Integer(number)
  return n > 0 ? n : 0
}

/**
 *
 * @param {number} start
 * @param {number?} end
 * @param {number?} length
 * @returns {[number, number, number]}
 */
Integer.toRange = function (start, end, length) {
  start = ~~start
  length = ~~length
  end = end === undefined ? length : ~~end
  const newLength = end - start

  return [
    start < length ? start : length,
    end < length ? end : length,
    (newLength < Integer.MAX_SAFE_INTEGER) ? newLength : Integer.MAX_SAFE_INTEGER
  ]
}

Integer.isSafe = function (number) {
  number = Number(number || 0)
  return number < Integer.MAX_SAFE_INTEGER && number > Integer.MIN_SAFE_INTEGER
}
